import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import MenuToggleReducer from '../redux/SideNavBarSlice';
import LoginReducer from '../redux/LoginSlice';

export const Store = configureStore({
    reducer: {
        menuToggle: MenuToggleReducer.reducer,
        appRefresh: LoginReducer.reducer
    },
});

export type AppDispatch = typeof Store.dispatch;
export type RootState = ReturnType<typeof Store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
